import React from "react";
import ReactDOM from "react-dom";
import { AdminPanel } from "./AdminPanel";

const adminPanel = document.getElementById("admin-panel");
const draftId = adminPanel.getAttribute("draftId");
const isAdmin = adminPanel.getAttribute("isAdmin") === "true";
const communityRole = adminPanel.getAttribute("communityRole");

ReactDOM.render(
  <AdminPanel
    draftId={draftId}
    isAdmin={isAdmin}
    communityRole={communityRole}
  />,
  adminPanel,
);
